/* eslint-disable react/no-unknown-property */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { externalURLs } from 'const';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function VideoSessionInstructions() {
  const classes = useStyles();
  const { t } = useTranslation('labels');

  return (
    <div className={classes.instructions}>
      <Typography variant="span" component="span">
        {t('still_facing_camera_or_microphone_issues')}
      </Typography>
      <div>
        <Typography variant="span" component="span">
          {t('check_out_our')}
        </Typography>
        <a className={classes.guideLink} sx={{ textTransform: 'lowercase' }} target="_blank" href={externalURLs.videoSessionSupport} rel="noreferrer">
          {' '}
          {t('step_by_step_guide')}{' '}
        </a>
        <Typography variant="span" component="span">
          {`${t('for_more_details')}.`}
        </Typography>
      </div>
    </div>
  );
}

export default VideoSessionInstructions;
